import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataInput, IUserSettingsAddProjectPathResponse } from '../../../../interface/interfaces';

interface IInitialState {
    userSettingsProjectPathLoading: boolean;
    userSettingsProjectPathData: IUserSettingsAddProjectPathResponse | null;
    userSettingsProjectPathError: string;
}



const initialState: IInitialState = {
    userSettingsProjectPathLoading: false,
    userSettingsProjectPathData: null,
    userSettingsProjectPathError: '',
};

const userSettingsProjectPathSlice = createSlice({
    name: 'userSettingsProjectPath',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchUserSettingsProjectPathPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.userSettingsProjectPathLoading = true;
            state.userSettingsProjectPathData = null;
            state.userSettingsProjectPathError = '';
        },

        fetchUserSettingsProjectPathFulfilled: (state: IInitialState, action: PayloadAction<IUserSettingsAddProjectPathResponse>) => {
            state.userSettingsProjectPathLoading = false;
            state.userSettingsProjectPathData = action.payload;
            state.userSettingsProjectPathError = '';
        },

        fetchUserSettingsProjectPathFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.userSettingsProjectPathLoading = false;
            state.userSettingsProjectPathData = null;
            state.userSettingsProjectPathError = action.payload;
        },
    },
});

export default userSettingsProjectPathSlice.reducer;
export const { fetchUserSettingsProjectPathPending, fetchUserSettingsProjectPathFulfilled, fetchUserSettingsProjectPathFailure } = userSettingsProjectPathSlice.actions;
